import Cookies from "js-cookie";
import {
  CREATE_HOME_WORK_COURSE_URL,
  UPDATE_HOME_WORK_COURSE_URL,
  GET_HOME_WORKS_COURSE_URL,
  GET_HOME_WORK_COURSE_URL,
  DELETE_HOME_WORK_COURSE_URL,
  CREATE_HOME_WORK_SUBJECT_URL,
  UPDATE_HOME_WORK_SUBJECT_URL,
  GET_HOME_WORKS_SUBJECT_URL,
  GET_HOME_WORK_SUBJECT_URL,
  DELETE_HOME_WORK_SUBJECT_URL,
  CREATE_HOME_WORK_TOPIC_URL,
  UPDATE_HOME_WORK_TOPIC_URL,
  GET_HOME_WORKS_TOPIC_URL,
  GET_HOME_WORK_TOPIC_URL,
  DELETE_HOME_WORK_TOPIC_URL,
  CREATE_HOME_WORK_SUB_TOPIC_URL,
  UPDATE_HOME_WORK_SUB_TOPIC_URL,
  GET_HOME_WORK_SUB_TOPIC_URL,
  DELETE_HOME_WORK_SUB_TOPIC_URL,
  GET_HOME_WORKS_SUB_TOPIC_URL,
  GET_HOME_WORK_ASSIGNED_STUDENTS_URL,
  GET_HOME_WORK_COMPLETED_STUDENTS_URL,
  GET_HOME_WORK_COMPLETED_STUDENT_URL,
  GET_ALL_TEACHER_COURSE_URL,
} from "../apiurls/apiurls";

const getInstitutionAuthToken = () => Cookies.get("institution_token");

const getInstitutionHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getInstitutionAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const getCompletedStudents = async (params = {}) => {
  const query = new URLSearchParams({});
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", String(params.search));
  if (params.level) query.set("level", String(params.level));
  if (params.id) query.set("id", String(params.id));
  if (typeof params.submitted === "boolean") {
    query.set("submission", params.submitted ? "true" : "false");
  }
  const url = `${GET_HOME_WORK_COMPLETED_STUDENTS_URL}?${query.toString()}`;
  const res = await fetch(url, {
    method: "GET",
    headers: getInstitutionHeaders(),
  });
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  const data = await res.json();
  if (params.page || params.limit) {
    return data;
  }
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.results)) return data.results;
  return [];
};

export const getCompletedStudent = async (params = {}) => {
  const query = new URLSearchParams({});
  if (params.id) query.set("id", String(params.id));
  const url = `${GET_HOME_WORK_COMPLETED_STUDENT_URL}?${query.toString()}`;
  const res = await fetch(url, {
    method: "GET",
    headers: getInstitutionHeaders(),
  });
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  const data = await res.json();
  return data;
};

export const getAllTeacherCourses = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", String(params.search));
  const url = query.toString()
    ? `${GET_ALL_TEACHER_COURSE_URL}?${query.toString()}`
    : `${GET_ALL_TEACHER_COURSE_URL}`;
  const res = await fetch(url, {
    method: "GET",
    headers: getInstitutionHeaders(),
  });
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  const data = await res.json();
  return data;
};

const deriveLevelFromPath = () => {
  try {
    const p = String(window?.location?.pathname || "").toLowerCase();
    if (p.includes("/subtopic")) return "subtopic";
    if (p.includes("/topic/")) return "topic";
    if (p.includes("/subject/")) return "subject";
    if (p.includes("/course/")) return "course";
  } catch (error) {
    console.error(error);
  }
  return "subject";
};

const resolveLevel = (level) =>
  String(level || deriveLevelFromPath()).toLowerCase();

const resolveUrls = (level) => {
  const key = resolveLevel(level);
  if (key === "course") {
    return {
      create: CREATE_HOME_WORK_COURSE_URL,
      update: UPDATE_HOME_WORK_COURSE_URL,
      list: GET_HOME_WORKS_COURSE_URL,
      get: GET_HOME_WORK_COURSE_URL,
      del: DELETE_HOME_WORK_COURSE_URL,
    };
  }
  if (key === "topic") {
    return {
      create: CREATE_HOME_WORK_TOPIC_URL,
      update: UPDATE_HOME_WORK_TOPIC_URL,
      list: GET_HOME_WORKS_TOPIC_URL,
      get: GET_HOME_WORK_TOPIC_URL,
      del: DELETE_HOME_WORK_TOPIC_URL,
    };
  }
  if (key === "subtopic" || key === "sub_topic") {
    return {
      create: CREATE_HOME_WORK_SUB_TOPIC_URL,
      update: UPDATE_HOME_WORK_SUB_TOPIC_URL,
      list: GET_HOME_WORKS_SUB_TOPIC_URL,
      get: GET_HOME_WORK_SUB_TOPIC_URL,
      del: DELETE_HOME_WORK_SUB_TOPIC_URL,
    };
  }

  return {
    create: CREATE_HOME_WORK_SUBJECT_URL,
    update: UPDATE_HOME_WORK_SUBJECT_URL,
    list: GET_HOME_WORKS_SUBJECT_URL,
    get: GET_HOME_WORK_SUBJECT_URL,
    del: DELETE_HOME_WORK_SUBJECT_URL,
  };
};

export const createHomework = async (payload, level) => {
  const urls = resolveUrls(level);
  const res = await fetch(urls.create, {
    method: "POST",
    headers: getInstitutionHeaders(),
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  return res.json();
};

export const updateHomework = async (payload, level) => {
  const urls = resolveUrls(level);
  const params = new URLSearchParams();
  if (payload?.id) params.append("id", payload.id);
  const res = await fetch(`${urls.update}?${params.toString()}`, {
    method: "PUT",
    headers: getInstitutionHeaders(),
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  return res.json();
};

export const getHomeworks = async (level, params = {}) => {
  const urls = resolveUrls(level);
  const query = new URLSearchParams({});
  if (params.batch) query.set("batch", String(params.batch));
  const url = query.toString() ? `${urls.list}?${query.toString()}` : urls.list;
  const res = await fetch(url, {
    method: "GET",
    headers: getInstitutionHeaders(),
  });
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  const data = await res.json();
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.data?.data)) return data.data.data;
  if (data?.results && Array.isArray(data.results)) return data.results;
  return [];
};

export const getHomeworkById = async (id, level) => {
  const urls = resolveUrls(level);
  const params = new URLSearchParams();
  if (id) params.append("id", id);
  const res = await fetch(`${urls.get}?${params.toString()}`, {
    method: "GET",
    headers: getInstitutionHeaders(),
  });
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  return res.json();
};

export const deleteHomework = async (id, level) => {
  const urls = resolveUrls(level);
  const params = new URLSearchParams();
  if (id) params.append("id", id);
  const res = await fetch(`${urls.del}?${params.toString()}`, {
    method: "DELETE",
    headers: getInstitutionHeaders(),
  });
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  return res.json();
};

export const getAssignedStudents = async (params = {}) => {
  const query = new URLSearchParams({});
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", String(params.search));
  if (params.level) query.set("level", String(params.level));
  if (params.id) query.set("id", String(params.id));
  const url = `${GET_HOME_WORK_ASSIGNED_STUDENTS_URL}?${query.toString()}`;
  const res = await fetch(url, {
    method: "GET",
    headers: getInstitutionHeaders(),
  });
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  const data = await res.json();
  if (params.page || params.limit) {
    return data;
  }
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.results)) return data.results;
  return [];
};
